/**
 * VerbaGPT Configuration - Hybrid Architecture
 *
 * Hybrid deployment model:
 * - Web App (Railway): Frontend + Backend for Virgo mode - works everywhere
 * - Local Taurus Server (Optional): Lightweight local service for advanced agentic mode
 *
 * Taurus availability is detected at runtime (no build-time mode switching needed)
 */

// API Endpoints
export const API_ENDPOINTS = {
  // Main backend (auth, settings, Virgo) - controlled by .env
  main: process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001',

  // Taurus backend - always points to localhost (detection happens at runtime)
  // Users with Taurus installed will have it available, others won't
  // Port 48002 chosen to avoid common conflicts (dynamic/private port range)
  taurus: process.env.REACT_APP_TAURUS_URL || 'http://localhost:48002',
};

// Feature flags
export const FEATURES = {
  // Show mode indicator in UI (for testing)
  showModeIndicator: process.env.NODE_ENV === 'development',
};

// App mode info (kept for backwards compatibility, but mode detection is now runtime)
export const APP_INFO = {
  // Taurus availability determined by runtime health check, not build-time flag
  taurusEnabled: true, // Always try to detect Taurus
};

// Log configuration (only in development)
if (process.env.NODE_ENV === 'development') {
  console.log('🔧 VerbaGPT Configuration:', {
    endpoints: API_ENDPOINTS,
    features: FEATURES,
    info: APP_INFO,
  });
}

export default {
  API_ENDPOINTS,
  FEATURES,
  APP_INFO,
};
